<template>
  <div class="wrapper">
    <div>
      <CToaster :autohide="3000">
        <template v-for="info in infoList">
          <CToast
            :key="info.message"
            :show="true"
            :header="info.header"
            :color="info.color"
          >
            {{ info.message }}.
          </CToast>
        </template>
      </CToaster>
      <CRow>
        <CCol sm="12">
          <CCard>
            <CCardHeader>
              <strong> Equipment </strong> Information
            </CCardHeader>
            <CCardBody>
              <CForm>
                <CInput label="Model" horizontal v-model="obj.model" />
                <CInput label="SerialNo" horizontal v-model="obj.serialNo" />
                <CInput label="IpAddress" horizontal v-model="obj.ipAddress" />
                <CInput
                  label="DefaultIpAddress"
                  horizontal
                  v-model="obj.defaultIpAddress"
                />
                <CInput label="Mask" horizontal v-model="obj.mask" />
                <CInput label="Gateway" horizontal v-model="obj.gateway" />
                <CInput label="Frequency" horizontal v-model="obj.frequency" />
                <CInput label="UserName" horizontal v-model="obj.userName" />
                <CInput label="Password" horizontal v-model="obj.password" />
                <CInput label="Url" horizontal v-model="obj.url" />
              </CForm>
            </CCardBody>
            <CCardFooter>
              <CButton type="submit" size="sm" color="primary" @click="submit"
                ><CIcon name="cil-check-circle" /> Submit</CButton
              >

              <CButton class="ml-1" color="secondary" @click="cancel">
                Cancel
              </CButton>
            </CCardFooter>
          </CCard>
        </CCol>
      </CRow>
    </div>
  </div>
</template>

<script>
import EquipmentApi from "../../lib/equipmentApi.js";

export default {
  name: "Equipment",
  data() {
    return {
      infoList: [],
      api: new EquipmentApi(),
      obj: {},
      warningModal: false,
      itemToControl: "",
      polling: null,
    };
  },
  mounted() {
    var self = this;
    self.resetObj();
  },

  methods: {
    showConfirmation(item) {
      var self = this;
      self.itemToControl = item;
      self.warningModal = true;
    },
    resetObj() {
      var self = this;
      if (self.$route.params.id) {
        this.api
          .get(self.$route.params.id)
          .then((response) => {
            self.obj = response.result;
            if (self.obj.packageCategories.length == 0) {
            } else {
              self.categoryList = self.obj.packageCategories;
            }
          })
          .catch(({ data }) => {
            self.toast("Error", helper.getErrorMessage(data), "danger");
          });
      } else {
        self.obj = self.getEmptyObj();
      }
    },
    toast(header, message, color) {
      var self = this;
      self.infoList.push({
        header: header,
        message: message,
        color: color,
      });
    },
    getEmptyObj() {
      return {
        code: "",
        name: "",
        model: "",
        cable: "",
        serialNo: "",
        ipAddress: "",
        defaultIpAddress: "",
        mask: "",
        gateway: "",
        frequency: "",
        userName: "",
        password: "",
        url: "",
      };
    },
    cancel() {
      this.$router.push({ path: "/equipments/EquipmentList" });
    },
    submit() {
      this.onSubmit();
    },
    onSubmit() {
      var self = this;

      if (!self.obj.id) {
        this.api
          .create(self.obj)
          .then((response) => {
            self.$router.push({ path: "/equipments/EquipmentList" });
          })
          .catch(({ data }) => {
            self.toast("Error", helper.getErrorMessage(data), "danger");
          });
      } else {
        this.api
          .update(self.obj)
          .then((response) => {
            self.$router.push({ path: "/equipments/EquipmentList" });
          })
          .catch(({ data }) => {
            self.toast("Error", helper.getErrorMessage(data), "danger");
          });
      }
    },
    onReset(evt) {
      evt.preventDefault();
      this.obj = {};
    },
  },
};
</script>
